import { AuthState } from "../base/AuthState";

import template from './ForgotPasswordTemplate.html';
import { _lcs, currentLanguage } from "../../i18n";
import { validateScope, bindLiveClear } from "../../components/general/form-validation";

/**
 * ForgotPasswordState — "Passwort vergessen?" from the login (#/password-forgotten).
 *
 * Asks for the account's e-mail address and has the core-api mail a reset link
 * (POST /auth/password-reset). The link leads to TokenState, which hands a
 * resetPassword token on to PasswordResetState.
 *
 * The confirmation reads the same whether or not the address has an account:
 * the API answers 200 either way so nobody can probe which addresses exist,
 * and the screen must not give away what the API keeps to itself.
 */
export class ForgotPasswordState extends AuthState
{
    static ROUTE = '/password-forgotten';
    static ID = 'password-forgotten';

    async enter()
    {
        this.sending = false;

        const host = this.app.container.querySelector( "#main-wrapper" ) || document.body;
        this.app.view.render( host, template );
        this.host = host;

        this.form = host.querySelector( '[data-id="forgot-form"]' );
        this.errorEl = host.querySelector( '[data-id="forgot-error"]' );
        bindLiveClear( this.form );

        this.addEventListener( this.form, "submit", ( e ) => this.onSubmit( e ) );

        const back = host.querySelector( '[data-id="btn-back-to-login"]' );
        this.addEventListener( back, "click", ( e ) =>
        {
            e.preventDefault();
            this.app.router.redirect( "/login" );
        } );

        host.querySelector( "#forgot-email" )?.focus();
    }

    async onSubmit( e )
    {
        e.preventDefault();
        if ( this.sending || !validateScope( this.form ) )
        {
            return;
        }

        const email = this.form.querySelector( "#forgot-email" ).value.trim();
        this.errorEl.hidden = true;
        this.setSending( true );
        try
        {
            const { result } = await this.app.api.post( "/auth/password-reset", {
                email,
                app : "admin",
                // The mail is written in the language the operator is using.
                language : currentLanguage()
            } );
            if ( !result || +result.status !== 200 )
            {
                throw new Error( "Unexpected password-reset response." );
            }
            this.showSent( email );
        }
        catch ( err )
        {
            console.error( err );
            this.setSending( false );
            this.errorEl.textContent = +err?.status === 400
                ? _lcs( "Bitte gib eine gültige E-Mail-Adresse ein." )
                : _lcs( "Der Link konnte nicht angefordert werden. Bitte versuche es später erneut." );
            this.errorEl.hidden = false;
        }
    }

    showSent( email )
    {
        this.host.querySelector( '[data-id="forgot-request"]' ).hidden = true;
        this.host.querySelector( '[data-id="forgot-sent-text"]' ).textContent = _lcs(
            "Falls zu {email} ein Konto existiert, haben wir dir einen Link zum Zurücksetzen geschickt. Er ist 2 Stunden gültig.",
            { email }
        );
        this.host.querySelector( '[data-id="forgot-sent"]' ).hidden = false;
    }

    setSending( on )
    {
        this.sending = on;
        const btn = this.form.querySelector( 'button[type="submit"]' );
        btn.disabled = on;
        btn.setAttribute( "aria-busy", String( on ) );
    }

    async exit()
    {
    }
}
